<div class="layout">

    <app-navigation authorized
        [forRoles]="['NineYardsAdmin','Admin', 'Buyer', 'AdnocCoordinator' ,'Supplier', 'SupplierAdmin', 'Reviewer', 'SuperAdmin', 'RoadshowFocalPoint','NirvanaFinance','MazayaSupport']"></app-navigation>
    <router-outlet></router-outlet>
    <app-footer authorized
        [forRoles]="['NineYardsAdmin','Admin', 'Buyer', 'AdnocCoordinator' ,'Supplier', 'SupplierAdmin', 'Reviewer', 'SuperAdmin', 'RoadshowFocalPoint','NirvanaFinance','MazayaSupport']"></app-footer>
    <notifications></notifications>
    <loader></loader>
</div>